module.exports = __webpack_public_path__ + "img/File.1a449d89.png";